import {Component, computed, input, output} from '@angular/core';
import {MatAnchor, MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {ProductCardData, ProductCardParameters} from "../../../../../types/product-card-data.types";
import {defaultProductCardData} from "../../../../../configs/default-product-card-data";
import {paramKey, productCardParamsData} from "../../configs/product-card-sync-tabs";

@Component({
  selector: 'div[app-pc-sync-product-card]',
  imports: [
    MatButton,
    MatIcon,
    MatAnchor
  ],
  templateUrl: './pc-sync-product-card.component.html',
  styleUrl: './pc-sync-product-card.component.scss'
})
export class PcSyncProductCardComponent {
  productCardData = input<ProductCardData>(defaultProductCardData);
  btnKey = input<string>('');
  currentParamKey = input<string>('');
  handleBtnClick = output<ProductCardData>();

  public readonly productCardParamsData = productCardParamsData;
  public isDetachKey = computed(() => this.btnKey() === 'detach');

  public getParamData(key: string): string {
    return (this.productCardData()[key] as ProductCardParameters)?.value || 'Не установлен';
  }

  public isSearchParam(key: string): boolean {
    return paramKey[this.currentParamKey() as keyof typeof paramKey] === key;
  }

  public handleBtn(): void {
    this.handleBtnClick.emit(this.productCardData());
  }

  public getImg(): string {
    return this.productCardData().photo || 'assets/images/fallback-image.svg';
  }

  public getUrlProductCard(): string {
    return `/records/product-card/${this.productCardData().id}`
  }
}
